<template>
  <div>
    Cash
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>